import React, { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { indicadoresNormasContext } from '../../IndicadoresNormas/IndicadoresNormas'
import "../ModalShowIndicador.scss"
import { Oval } from 'react-loader-spinner'
import IllustrationAccess from "../../../assets/img/access.png"
// chart
import { Bar } from 'react-chartjs-2'
import { 
  Chart as ChartJS,
  BarElement,
  Tooltip,
  CategoryScale,
  LinearScale,
  Legend
} from "chart.js";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);


function ModalVerIndicador(props) {

    const { 
        user,  
        objIndicador, 
        setObjIndicador,
        errorMetricas, 
        setErrorMetricas,
        arrTresMetricas,
        setArrTresMetricas,
        showIndicador
    } =  useContext(indicadoresNormasContext)
    
    const [arrMetrica, setArrMetrica] = useState(null)
    const [arrMetaEsperada, setMetaEsperada] = useState(null)
    const [arrLabels, setArrLabels] = useState(null)
    const [formMetrica, setFormMetrica] = useState(false)
    const [formEditMetrica, setFormEditMetrica] = useState(false)

    const [loadingMet, setLoadingMet] = useState(false)

    const [newLog, setNewLog] = useState({
        log: "",
        meta: ""
    })

    const [editLog, setEditLog] = useState({
        log: "",
        meta: ""
    })

    const [errorNewLog, setErrorNewLog] = useState({})
    const [errorLogFetch, setErrorLogFetch] = useState(null)

    const [idMetrica, setIdMetrica] = useState(null)

    useEffect(() => {
        if(loadingMet){
            showIndicador(objIndicador.id_indicador)
            setLoadingMet(false)
        }
        let arrMet = []
        let arrMetaEsperada = []
        let arrLabel = []
        arrTresMetricas.forEach((e) => {
            arrMet.push(parseInt(e.dato_metrica))
            arrMetaEsperada.push(parseInt(e.valor_esperado))
            arrLabel.push((e.fecha_metrica.slice(0,10)).replace(/-/g, '/').split("/").reverse().join("/"))
        })
        arrMet.reverse()
        arrMetaEsperada.reverse()
        arrLabel.reverse()
        setArrMetrica(arrMet)
        setMetaEsperada(arrMetaEsperada)
        setArrLabels(arrLabel)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrTresMetricas, loadingMet])

    const handleClose = () => {
        props.onHide()
        setArrTresMetricas([])
        setObjIndicador({})
        setErrorNewLog({})
        setNewLog({
            log: "",
            meta: ""
        })
        setErrorLogFetch(null)
        setFormMetrica(false)
        setFormEditMetrica(false)
        setErrorMetricas(null)
    }

    const colores = Array.isArray(objIndicador.color)
        ? objIndicador.color
        : Object.values(objIndicador.color || []);

    const data = {
        labels: arrLabels,
        datasets : [
            {
                label: "Valor real",
                data: arrMetrica,
                backgroundColor: colores[1],
                borderWidth: 1
            },
            {
                label: "Valor esperado",
                data: arrMetaEsperada,
                backgroundColor: colores[0],
                borderWidth: 1
            }
        ]
    }

    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewLog({
            ...newLog,
            [name]: value,
        })
    }

    const handleChangeEdit = (e) => {
        const { name, value } = e.target;
        setEditLog({
            ...editLog,
            [name]: value,
        })
    }

    const validateFormLog = (data) => {
        const errors = {}
        if(!data.log.trim()) {
            errors.log = "Escriba el valor real."
        }
        if(!data.meta.trim()) {
            errors.meta = "Escriba el valor de la meta esperada."
        }
        return errors;
    }

    const newMetrica = async (e) => {
        e.preventDefault()
        const errorLog = validateFormLog(newLog)
        setErrorNewLog(errorLog)
        if(Object.keys(errorLog).length === 0){
            const obj = {
                fk_indicador: parseInt(objIndicador.id_indicador),
                dato_metrica: parseInt(newLog.log),
                dato_futura_metrica: parseInt(newLog.meta),
                user
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/newMetrica`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status
                if(errorCode !== 0){
                    setErrorLogFetch(data.errorDetalle || data.codeError)
                } else {
                    setNewLog({
                        log: "",
                        meta: ""
                    })
                    setFormMetrica(false)
                    setLoadingMet(true)
                }
            } catch (error) {
                setErrorLogFetch("Error: Conexión con backend.")
            }
        } else {
            setErrorLogFetch("Completar los campos mencionados.")
        }
    }

    const handleShowForm = () => {
        setFormMetrica(true)
    }

    const handleCloseForm = () => {
        setFormMetrica(false)
        setFormEditMetrica(false)
        setErrorNewLog({})
        setNewLog({
            log: "",
            meta: ""
        })
        setEditLog({
            log: "",
            meta: ""
        })
        setErrorLogFetch(null)
        setIdMetrica(null)
    }

    // EDITAR METRICA
    const showEditMetrica = (id) => {
        const obj = arrTresMetricas.find(e => e.id_metrica === id)
        setEditLog({
            log: String(obj.dato_metrica ?? ""),
            meta: String(obj.valor_esperado ?? "")
        })
        setIdMetrica(id)
        setFormEditMetrica(true)
    }

    const editarMetrica = async (e) => {
        e.preventDefault()
        const errorLog = validateFormLog(editLog)
        setErrorNewLog(errorLog)
        if(Object.keys(errorLog).length === 0){
            const obj = {
                idMetrica: parseInt(idMetrica),
                dato_metrica: parseInt(editLog.log),
                valor_esperado: parseInt(editLog.meta),
                user
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/editMetrica`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status
                if(errorCode !== 0){
                    setErrorLogFetch(data.errorDetalle || data.codeError)
                } else {
                    setEditLog({
                        log: "",
                        meta: ""
                    })
                    setFormEditMetrica(false)
                    setIdMetrica(null)
                    setLoadingMet(true)
                }

            } catch (error) {
                setErrorLogFetch("Error: Conexión con backend.")
            }
        } else {
            setErrorLogFetch("Completar los campos mencionados.")
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__showIndicador'
            dialogClassName={props.dialogClassName}
        >
            {loadingMet ? (
                <Modal.Body>
                    <div className='loading__datin d-flex flex-column align-items-center justify-content-center'>
                        <Oval
                            visible={true}
                            height="80"
                            width="80"
                            color="#0d6efd"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                        <p className='fw-medium'>Loading...</p>
                    </div>
                </Modal.Body>
            ) : (
                <>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                            <h3 className='m-0'>Información del indicador</h3>
                            <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {errorMetricas ? (
                            <div className='modal__showIndicador--error d-flex flex-column align-items-center'>
                                <img className='mb-3' src={IllustrationAccess} alt='' />
                                <h3 className='text-blue-500'>Error:</h3>
                                <p>{errorMetricas}</p>
                            </div>
                        ) : (
                            <div className='d-flex flex-column'>
                                <div className='indicador__textos mb-4 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between'>
                                    <div className='mb-2'>
                                        <h2 style={{color:colores[0]}} className='m-0'>{objIndicador.nombre_indicador}</h2>
                                        <p className='m-0'><span className='text-secondary'>Descripción: </span>{objIndicador.detalles_metrica}</p>
                                        <p className='m-0'>
                                            <span className='text-secondary'>Frecuencia: </span>
                                            {objIndicador.tipo_recordartorio === 1 && "Semanal"}
                                            {objIndicador.tipo_recordartorio === 2 && "Quincenal"}
                                            {objIndicador.tipo_recordartorio === 3 && "Mensual"}
                                            {objIndicador.tipo_recordartorio === 4 && "Trimestral"}
                                        </p>
                                    </div>
                                    {(user.puesto === 1 || user.puesto === 2 || user.puesto === 3) && (
                                        <button 
                                            onClick={handleShowForm}
                                            className='btn btn-primary rounded-pill shadow-sm fw-medium px-4'
                                        >
                                            + agregar métrica
                                        </button>
                                    )}
                                </div>
                                <div className='d-flex flex-column-reverse flex-md-row gap-4'>
                                    <div className='indicador__logs d-flex flex-column'>
                                        {arrTresMetricas.map((metrica, i) => (
                                            <div key={i} className='eachMetrica p-2 border border-1 border-light-subtle shadow-sm rounded-2 cursor-pointer'>
                                                <div className='d-flex flex-row align-items-center'>
                                                    <i className="bi bi-person-circle me-2 text-primary"></i>
                                                    <p className='m-0'>{metrica.Empleados?.nombre}</p>
                                                </div>
                                                <div className='d-flex flex-row align-items-center'>
                                                    <i className='bi bi-bar-chart-fill me-2 text-primary'></i>
                                                    <p className='m-0'>{metrica.dato_metrica}</p>
                                                </div>
                                                <div className='d-flex flex-row align-items-center justify-content-between'>
                                                    <div className='d-flex flex-row align-items-center'>
                                                        <i className="bi bi-calendar-event me-2 text-primary"></i>
                                                        <p className='m-0'>
                                                            {(metrica.fecha_metrica.slice(0,10)).replace(/-/g, '/').split("/").reverse().join("/")}
                                                        </p>
                                                    </div>
                                                    <div className='d-flex flex-row align-items-center'>
                                                        <i className="bi bi-clock me-2 text-primary"></i>
                                                        <p className='m-0'>{(metrica.fecha_metrica.slice(11,17))}</p>
                                                    </div>
                                                </div>
                                                {(user.puesto === 1 || user.puesto === 2 || user.puesto === 3) && (
                                                    <div className='btn__editMetrica p-2 active'>
                                                        <button 
                                                            onClick={()=>showEditMetrica(metrica.id_metrica)} 
                                                            className='btn bg-success rounded-circle mb-2 text-white'
                                                        >
                                                            <i className="bi bi-pencil text-white"></i>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                    <div className='indicador__grafica'>
                                        <div className=''>
                                            <Bar data={data} options={options} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    {/* EDITAR METRICA */}
                    {editLog && <>
                        {formEditMetrica && <Modal.Footer>
                            <div className='form__metrica d-flex flex-column align-items-center w-100'>
                                <div className='w-100 form__metrica--header d-flex flex-row align-items-center justify-content-between'>
                                    <h4 className='m-0 fw-medium text-dark'>Edita la métrica</h4>
                                    <button className='btn py-0' onClick={handleCloseForm}><i className="bi bi-x-lg fw-bold"></i></button>
                                </div>
                                <form onSubmit={editarMetrica} className='w-100 d-flex flex-column'>
                                    <div className='row mb-3'>
                                        {/* Valor real */}
                                        <div className='form__input col-12 col-md-6'>
                                            <label className='fw-medium text-blue-500 mb-1'>Modifica el valor real</label>
                                            <input
                                                onChange={handleChangeEdit}
                                                type="number"  
                                                name="log" 
                                                autoFocus
                                                className="input--arrows form-control form-control-sm"
                                                value={editLog.log}
                                            />
                                            {errorNewLog.log && <span className='formDataIn__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errorNewLog.log}</span>}
                                        </div>
                                        {/* Valor meta */}
                                        <div className='form__input col-12 col-md-6'>
                                            <label className='fw-medium text-blue-500 mb-1'>Modifica la meta esperada</label>
                                            <input
                                                onChange={handleChangeEdit}
                                                type="number"  
                                                name="meta"
                                                className="input--arrows form-control form-control-sm"
                                                value={editLog.meta}
                                            />
                                            {errorNewLog.meta && <span className='formDataIn__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errorNewLog.meta}</span>}
                                        </div>
                                    </div>
                                    {errorLogFetch && <span className='formDataIn__error d-flex flex-row align-self-center align-items-center my-2'><i className="bi bi-exclamation-circle me-1"></i>{errorLogFetch}</span>}
                                    <button type="submit" className='btn__metrica btn btn-primary rounded-pill shadow-sm fw-medium align-self-center px-3'>Modificar métrica</button>
                                </form>
                            </div>
                        </Modal.Footer>}
                    </>}
                    {/* CREAR METRICA */}
                    {formMetrica && <Modal.Footer>
                        <div className='form__metrica d-flex flex-column align-items-center w-100'>
                            <div className='w-100 form__metrica--header d-flex flex-row align-items-center justify-content-between'>
                                <h4 className='m-0 fw-medium text-dark'>Ingresa la métrica</h4>
                                <button className='btn py-0' onClick={handleCloseForm}><i className="bi bi-x-lg fw-bold"></i></button>
                            </div>
                            <form onSubmit={newMetrica} className='w-100 d-flex flex-column'>
                                <div className='row mb-3'>
                                    {/* Valor real */}
                                    <div className='form__input col-12 col-md-6'>
                                        <label className='fw-medium text-blue-500 mb-1'>Ingresa el valor real</label>
                                        <input
                                            onChange={handleChange}
                                            type="number"  
                                            name="log" 
                                            autoFocus
                                            className="input--arrows form-control form-control-sm"
                                            value={newLog.log}
                                        />
                                        {errorNewLog.log && <span className='formDataIn__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errorNewLog.log}</span>}
                                    </div>
                                    {/* Valor meta */}
                                    <div className='form__input col-12 col-md-6'>
                                        <label className='fw-medium text-blue-500 mb-1'>Ingresa la meta esperada</label>
                                        <input
                                            onChange={handleChange}
                                            type="number"  
                                            name="meta"
                                            className="input--arrows form-control form-control-sm"
                                            value={newLog.meta}
                                        />
                                        {errorNewLog.meta && <span className='formDataIn__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errorNewLog.meta}</span>}
                                    </div>
                                </div>
                                {errorLogFetch && <span className='formDataIn__error d-flex flex-row align-self-center align-items-center my-2'><i className="bi bi-exclamation-circle me-1"></i>{errorLogFetch}</span>}
                                <button type="submit" className='btn__metrica btn btn-primary rounded-pill shadow-sm fw-medium align-self-center px-3'>Insertar métrica</button>
                            </form>
                        </div>
                    </Modal.Footer>}
                </>
            )}
        </Modal>
    )
}

export default ModalVerIndicador